import React from 'react';

export const Instagram = () => (
    <g>
        <path d='M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M12,23C5.935,23,1,18.066,1,12
			C1,5.935,5.935,1,12,1s11,4.935,11,11C23,18.066,18.065,23,12,23z' />
        <path d='M16.167,5H7.833C6.271,5,5,6.27,5,7.832v8.334C5,17.729,6.271,19,7.833,19h8.334C17.729,19,19,17.729,19,16.166V7.832
			C19,6.27,17.729,5,16.167,5z M18,7.832V9h-3.559C13.811,8.383,12.95,8,12,8c-0.744,0-1.432,0.238-2,0.635V6h6.167
			C17.178,6,18,6.822,18,7.832z M8,6h1v3H8V6z M12,9c1.379,0,2.5,1.122,2.5,2.5S13.379,14,12,14s-2.5-1.122-2.5-2.5S10.621,9,12,9z
			 M7,6.21V9H6V7.832C6,7.123,6.409,6.514,7,6.21z M16.167,18H7.833C6.822,18,6,17.177,6,16.166V10h2.852
			C8.633,10.457,8.5,10.961,8.5,11.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5c0-0.539-0.133-1.043-0.352-1.5H18v6.166
			C18,17.177,17.178,18,16.167,18z' />
        <rect x='16' y='7' width='1' height='1' />
    </g>
);